import React from "react";
import ArrowIcon from "../../../icons/arrow.icon";
import { StatCardData } from "./index";

export const getMockStatsData = (styles: Record<string, string>): StatCardData[] => [
  {
    title: "Subscription",
    badge: {
      text: "Paid Plan 1",
      bgColor: styles.badgeSuccess,
      textColor: styles.badgeSuccessText,
    },
    value: "24",
    unit: "days until renewal",
    showShareIcon: true,
  },
  {
    title: "Total Revenue",
    value: "€ 934.00",
    unit: "",
    footer: {
      text: "4 months on Paid Plan 1",
    },
  },
  {
    title: "Over Subscription",
    value: "4",
    unit: "clients",
  },
  {
    title: "Trial Time",
    value: "24",
    unit: "days",
    footer: {
      text: "+2.5% below avg.",
      icon: <ArrowIcon fill="currentColor" width={12} height={12} style={{ transform: `rotate(${false ? -45 : 45}deg)`, marginRight: '4px' }} />,
      textColor: styles.badgeSuccessText,
    },
  },
];

